module.exports = __webpack_public_path__ + "assets/xxadd1.3e3eaabce7161ad2ac864e5c60b6692e.png";